import Image from "next/image";
import { getImage } from "@/lib/images";

// Wrapper next/image autour du catalogue src/lib/images.js — impose alt,
// dimensions et sizes. Pas de `priority` (voir doc réutilisation d'images) :
// utiliser `preload` uniquement sur l'image LCP identifiée d'une page.
export default function ContentImage({
  imageId,
  alt,
  decorative = false,
  sizes = "(max-width: 768px) 100vw, 50vw",
  className = "",
  ...props
}) {
  const image = getImage(imageId);

  return (
    <Image
      src={image.src}
      width={image.width}
      height={image.height}
      alt={decorative ? "" : alt || image.alt}
      sizes={sizes}
      className={className}
      {...props}
    />
  );
}
